import {
  AnalysisPlanRequestDto,
  CampaignUpdateRequestDto,
  CustomerRequestDto,
} from '@shared/services/apiService/apiService';
import { CreateCampaignFormValue } from '../model/type';
import { normalizeCampaignAnalysisPlan } from './analysis-plan';

export const campaignRequestMapper = (
  data: CreateCampaignFormValue,
  customers: CustomerRequestDto[] | undefined,
) => {
  const normalizedAnalysisPlan = normalizeCampaignAnalysisPlan(data.analysisPlan);
  const analysisPlan = {
    ...normalizedAnalysisPlan,
    analysisTemplate:
      normalizedAnalysisPlan.analysisTemplate === ''
        ? null
        : normalizedAnalysisPlan.analysisTemplate,
  } as AnalysisPlanRequestDto & { analysisTemplate?: string | null };
  const mappedForm: CampaignUpdateRequestDto = {
    title: data.title,
    retryIntervalInMinutes: data.retryIntervalInMinutes,
    retryMaxNumber: data.retryMaxNumber,
    retriesPerDay: data.retriesPerDay,
    ...(customers !== undefined && {
      customers: customers.map((c) => {
        const id = c.id?.startsWith('file') || c.id?.startsWith('new') ? undefined : c.id;
        const gender = c.gender === 'male' || c.gender === 'female' ? c.gender : undefined;

        return {
          id,
          number: c.number && c.number !== '' ? c.number : undefined,
          name: c.name,
          gender,
          ...(c.attributes !== undefined && { attributes: c.attributes }),
          ...(c.metadata !== undefined && { metadata: c.metadata }),
        };
      }),
    }),
    callSchedule: data.callSchedule,
    productDetails: data.productDetails,
    analysisPlan: analysisPlan as CampaignUpdateRequestDto['analysisPlan'],
    reservedLimit: data.reservedLimit,
  };
  return mappedForm;
};
